import { useEffect, useMemo } from 'react';
import useReactHookFormProps from '../../../hooks/useReactHookFormProps';

const useApplicationStatusSingleSelect = ({
  handleApplicationStatusChange,
  statusUpdateAllowed,
  disableStatusChange,
  disableWaitlistOption,
  addToWaitlistParams,
  applicationStatusOptions,
  applicationStatusId,
  currentStatusId,
  cancelApplicationParams,
  denyApplicationParams,
  statusTracker = false,
}) => {
  const ReactHookFormProps = useReactHookFormProps({});
  const { reset, setValue, watch } = ReactHookFormProps;

  const currentStatus = watch('applicationStatusId');

  useEffect(() => {
    if (
      statusUpdateAllowed &&
      currentStatus !== undefined &&
      currentStatus !== null &&
      applicationStatusId !== currentStatus
    ) {
      handleApplicationStatusChange(
        null,
        currentStatus,
        addToWaitlistParams,
        cancelApplicationParams,
        denyApplicationParams,
      );
    }

    // Only update when [currentStatus] changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStatus]);

  useEffect(() => {
    const defaultValues = {
      applicationStatusId: applicationStatusId,
    };

    reset(defaultValues);
  }, [reset, applicationStatusId]);

  const { formProps } = useMemo(() => {
    const props = {
      formProps: {},
    };

    props.formProps = {
      fields: [
        {
          variant: 'singleSelect',
          name: 'applicationStatusId',
          label: statusTracker ? '' : 'Status',
          options: applicationStatusOptions,
          HelperTextProps: {
            sx: {
              display: 'none',
            },
          },
          disabled: disableStatusChange,
        },
      ],
    };

    return props;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    statusTracker,
    applicationStatusOptions,
    disableStatusChange,
    // neccessary to avoid issues when updating from statusA to statusB and viceversa
    currentStatusId,
  ]);

  return {
    ReactHookFormProps,
    formProps,
    setValue,
  };
};

export default useApplicationStatusSingleSelect;
